module.exports = __webpack_public_path__ + "static/media/SuraSans-Seminegrita.00730bd6.woff2";